import { render, staticRenderFns } from "./FeedDialog.vue?vue&type=template&id=55fed942&scoped=true"
import script from "./FeedDialog.vue?vue&type=script&lang=js"
export * from "./FeedDialog.vue?vue&type=script&lang=js"
import style0 from "./FeedDialog.vue?vue&type=style&index=0&id=55fed942&prod&lang=scss&scoped=true"
import style1 from "./FeedDialog.vue?vue&type=style&index=1&id=55fed942&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fed942",
  null
  
)

export default component.exports